import React, { useContext } from "react";
import pptpage from './RealTimeGlossary.pdf'
import DashboardMain from "../DashboardMain/DashboardMain";

function PPTPageDIC() {
  return (
    <>
      <DashboardMain>
        <iframe src={pptpage} style={{ marginTop: "7%" }} frameborder="0" height="500em" width="100%" sandbox></iframe>
      </DashboardMain>
    </>
  );
}

export default PPTPageDIC;